export default function buildAssetPath(path: string): string {
  return `${process.env.ASSETS_URL}/${path}`;
}
